import type { FaireProductEntity } from "../../entity_types/product";

export const p_bwgkxymtc6: FaireProductEntity = {
  token: "p_bwgkxymtc6",
  type: "product",
  name: "Gay Gourmet Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/7582638a3563a145dcf4c44c10777f9b8b8cca68f591c7e6fdfdb9ee8bc9e822.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/054cb18617b5f2f4b2266e49e73119858dff400bc8810176fa4902d97b025734.jpeg",
    "https://cdn.faire.com/fastly/5999b732a82c9695c1c812e8b53cea7ab9ea4b1ca495317de7b0f4f07b3de704.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/689eac55b77acd75e91695fefeeab32ddfafdd3631c28950e7512cea31689a43.jpeg",
    "https://cdn.faire.com/fastly/523fdf1219e73e18f7178a269a1dcaedd1fdc869d2bd8f0fff96ec1dbed76de1.jpeg",
    "https://cdn.faire.com/fastly/ba3af23351ad68a0e038fea73eb5c22dc7d6cadb6b268c15b15d1b131197aa34.jpeg",
    "https://cdn.faire.com/fastly/ed6e72fc2b298865e951a76212ca4007ae764806aebed3ff0c830dd25dcc608d.jpeg"
  ],
  priceDollars: 3.38,
  description: "Limited Availability - Will Not Restock\n\nFor when your taste is impeccable — and not just in men. 😉🧑 🍳\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:31:25.614Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
